import { useQuery } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function fetchAutocompleteGeocoder(query) {
    const data = await client(`geocoding/search-places/?location=${query}`)
    return data
}

export function useAutocompleteGeocoder(query) {
    return useQuery(['geocoder', query],
                    () => fetchAutocompleteGeocoder(query), {
        refetchAllOnWindowFocus: false,
        enabled: false,
        keepPreviousData: false,
        ...queryConfig
    });
}